<template>
  <el-row class="page-fitter">
    <el-select
      v-model="fitter.company_name.key"
      filterable
      remote
      reserve-keyword
      placeholder="请输入公司名称筛选公司"
      size="mini"
      clearable
      :remote-method="searchRemoteCompanyMethod"
      :loading="searchLoading"
      @change="handleSearchCompanyChange"
    >
      <el-option
        v-for="company in searchCompanies"
        :key="company"
        :label="company"
        :value="company"
      >
      </el-option>
    </el-select>
    <company-clue-fitter :fitter="fitter" @search="handleSearch" />
    <el-popover placement="bottom-start" v-model="searchVisible">
      <el-form :model="fitter" ref="searchForm" label-width="100px">
        <el-form-item label="风险信息" prop="select_key">
          <el-select style="width: 100%;" v-model="fitter.select_key" placeholder="请选择" size="mini" @change="resetForm('searchForm')">
            <el-option
              v-for="item in selectKeys"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key !== '行政处罚'" label="案号" prop="executor.key">
          <el-input size="mini" v-model="fitter.executor.key" placeholder="案号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '行政处罚'" label="决定文书号" prop="docNum.key">
          <el-input size="mini" v-model="fitter.docNum.key" placeholder="决定文书号"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '行政处罚'" label="处罚单位" prop="unit.key">
          <el-input size="mini" v-model="fitter.unit.key" placeholder="处罚单位"></el-input>
        </el-form-item>
        <el-form-item v-show="fitter.select_key !== '司法案件' && fitter.select_key !== '裁判文书' && fitter.select_key !== '行政处罚'" label="立案日期" prop="filingDate.key">
          <el-date-picker
            v-model="fitter.filingDate.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '失信被执行人' || fitter.select_key === '限制高消费' || fitter.select_key === '裁判文书'" label="发布日期" prop="releaseDate.key">
          <el-date-picker
            v-model="fitter.releaseDate.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '终本案件'" label="终本日期" prop="finaDate.key">
          <el-date-picker
            v-model="fitter.finaDate.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '司法案件'" label="案件类型" prop="caseType.key">
          <el-select v-model="fitter.caseType.key" multiple clearable placeholder="请选择" size="mini">
            <el-option
              v-for="item in caseTypes"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '司法案件'" label="进程日期" prop="process.key">
          <el-date-picker
            v-model="fitter.process.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-show="fitter.select_key === '裁判文书'" label="裁判日期" prop="refereeDate.key">
          <el-date-picker
            v-model="fitter.refereeDate.key"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="handelClearSearch('searchForm')" size="mini">重置</el-button>
          <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button slot="reference" size="mini">风险信息筛选</el-button>
    </el-popover>
  </el-row>
</template>

<script>
import CompanyClueFitter from "./CompanyClueFitter.vue"
export default {
  name: 'CompanyRisksFitter',
  components: { CompanyClueFitter },
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      searchLoading: false,
      searchCompanies: [],
      searchVisible: false,
      selectKeys: ['失信被执行人', '终本案件', '司法案件', '限制高消费', '被执行人', '裁判文书', '行政处罚'],
      caseTypes: ['执行案件', '民事案件', '刑事案件', '行政案件', '管辖案件', '保全案件'],
    }
  },
  methods: {
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true
        setTimeout(() => {
          this.searchArrItemCompanys(query)
        }, 200);
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/upload_tasks/risks/companies?name=" + query + '&type=1', { loadingClose: true }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
          this.searchLoading = false
        }
      })
    },
    handleSearchCompanyChange(val) {
      this.$emit('search', this.fitter)
    },
    handelClearSearch (formName) {
      this.$refs[formName].resetFields()
      this.searchVisible = false
      this.$emit('search', false)
    },
    submitForm(formName) {
      this.searchVisible = false
      this.$emit('search', false)
    },
    resetForm (formName) {
      this.fitter.executor.key = ''
      this.fitter.docNum.key = ''
      this.fitter.filingDate.key = ''
      this.fitter.releaseDate.key = ''
      this.fitter.finaDate.key = ''
      this.fitter.process.key = ''
      this.fitter.caseType.key = ''
      this.fitter.refereeDate.key = ''
      this.fitter.unit.key = ''
    },
    handleSearch (search) {
      this.$emit('search', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-fitter >>> .el-input {
  width: auto;
}
.el-form-item {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyRisksFitter.vue